(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cuumy-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cuumy-bundle')) {
  customElements.define('cuumy-bundle', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.rows = [...this.querySelectorAll('.cuumy-bundle__row')];
      if (!this.rows.length) { this.hidden = true; return; }
      this.querySelectorAll('input,select').forEach(input => { input.disabled = false; });
      this.rows.forEach(row => {
        const select = row.querySelector('select');
        const image = row.querySelector('img');
        const defaultImage = image?.getAttribute('src');
        const defaultSrcset = image?.getAttribute('srcset');
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          row.querySelector('.cuumy-bundle__price').textContent = option.dataset.price;
          if (image) {
            if (option.dataset.image) {
              image.src = option.dataset.image;
              image.removeAttribute('srcset');
            } else {
              image.src = defaultImage;
              if (defaultSrcset) image.srcset = defaultSrcset;
            }
          }
        }, options);
      });
      this.addEventListener('change', () => this.syncCheckout(), options);
      this.form.addEventListener('formdata', event => {
        const selected = this.rows.filter(row => row.querySelector('input').checked);
        if (!selected.length) return;
        const data = event.formData;
        for (const [key, value] of [...data.entries()]) {
          if (['id','quantity','selling_plan'].includes(key) || key.startsWith('properties[')) {
            data.delete(key);
            const nested = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : 'items[0][' + key + ']';
            data.append(nested, value);
          }
        }
        selected.forEach((row, index) => {
          data.append('items[' + (index + 1) + '][id]', row.querySelector('select').value);
          data.append('items[' + (index + 1) + '][quantity]', '1');
        });
      }, options);
      this.syncCheckout();
    }
    syncCheckout() {
      const selected = this.rows.some(row => row.querySelector('input').checked);
      this.querySelector('.cuumy-bundle__notice').hidden = !selected;
      this.form.querySelectorAll('.shopify-payment-button,shopify-accelerated-checkout').forEach(button => {
        if (selected) {
          if (!this.checkoutVisibility) this.checkoutVisibility = new Map();
          if (!this.checkoutVisibility.has(button)) this.checkoutVisibility.set(button, button.style.display);
          button.style.display = 'none';
        } else if (this.checkoutVisibility?.has(button)) {
          button.style.display = this.checkoutVisibility.get(button);
          this.checkoutVisibility.delete(button);
        }
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.checkoutVisibility?.forEach((display, button) => { button.style.display = display; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
